import AppTransition from './AppTransition.vue'

export default AppTransition

export type {
  TransitionName,
} from './types'
